import { Add } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Button,
  Chip,
  ClickAwayListener,
  Grid,
  IconButton,
  MenuItem,
  MenuList,
  Modal,
  Paper,
  Popper,
  Skeleton,
  TableBody,
  TablePagination,
  TableSortLabel,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Grow from '@mui/material/Grow';
import SvgIcon from '@mui/material/SvgIcon';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import PlusIcon from '@untitled-ui/icons-react/build/esm/Plus';
import { format } from 'date-fns';
import { useCallback, useEffect, useMemo, useRef, useState, type FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import loader from 'src/components/LoaderImg/loader.gif';
import { Scrollbar } from 'src/components/scrollbar';
import {
  DocDuePnAlert
} from 'src/config';
import useFeatureToggle, { useFeatureToggleWhenReady } from 'src/hooks/use-feature-toggle';
import { useStopwatch } from 'src/layouts/check-in-checkout/StopwatchContext';
import ClockInOutModal from 'src/pages/therapist-dashboard/time-in-out/clock-in-out-modal';
import { paths, permissions } from 'src/paths';
import {
  checkPendingDocsAlertAction,
  deleteRequiredDocumentAction,
  getEocDocumentCreateDataAction,
  resetPendingDocsAlertAction,
  requestDocDueSettings,
  resetDeleteRequiredDocumentAction,
  resetEocDocumentCreateDataAction,
  resetUuidAction,
} from 'src/redux/actions/documentationAction';
import { getEpisodeOfCareRequiredDocument } from 'src/redux/actions/patientEpisodeOfCare';
import { checkSupervisorPermission } from 'src/utils/checkSignatureAccess';
import GetDocumentIcon from 'src/utils/get-document-icons';
import { getDisplayString } from 'src/utils/getDaysBtDate';
import useDialogVisibility from '../../utils/dialog-hide';
import { BootstrapDialog } from '../common-modals/BootstrapDialog';
import Status from '../status/status';
import SucessModal from '../sucess-modal';
import CommonConfirmDeleteModal from './delete-alert-modal';
import {
  deleteDocumentAlertTreatment,
  reFormsPtEvalTreatment,
  reFormsOtEvalTreatment,
  reFormsSlpEvalTreatment,
  reFormsPtProgressNoteTreatment,
  reFormsOtProgressNoteTreatment,
  reFormsSlpProgressNoteTreatment,
  reFormsOtRecertTreatment,
  reFormsPtRecertTreatment,
  reFormsSlpRecertTreatment,
  reFormsOtDischargeTreatment,
  reFormsPtDischargeTreatment,
  reFormsSlpDischargeTreatment,
  reFormsDraftDocumentList,
  recheckDischarge,
} from 'src/config';
import { useTheme } from '@mui/system';
import { DraftDocument, getDraftDocuments } from 'src/services/documentService/getDraftDocuments';
import { getRealmName } from 'src/routes/AuthContext';
import moment from 'moment';
import DischargeRecheckModal from '../common-modals/discharge-recheck-modal';
import { getOldestRequiredDocumentUuid } from 'src/utils/getOldestRequiredDocumentUuid';

type Props = {
  activeTab: string;
  abortControllerScheduledDocumentRef: any;
  openPrintMode?: any;
};

interface DocumentData {
  documentType: string;
  dueDate: string;
  lastUpdatedOn: string;
  status: string;
  uuid: string;
  formId: string;
  dueDateString: string;
  lastUpdatedOnString: string;
  type: string;
  formType: string;
  visits: string;
}

interface NavigateDoc {
  formId: string;
  formType: string;
  fromMaster: boolean;
  uuid: string;
}

const columns: any = [
  { id: 'documentType', label: 'Document Type' },
  { id: 'dueDate', label: 'Due Date' },
  { id: 'visit', label: 'Treatment Visits Completed' },
  { id: 'dueStatus', label: 'Status' },
  { id: 'action', label: '', align: 'right' },
];

const ViewDocumentList: FC<Props> = (props: Props) => {
  const { activeTab, abortControllerScheduledDocumentRef, openPrintMode } = props;
  const { formattedTime, isRunning, startStopwatch, stopStopwatch, time } = useStopwatch();

  const { canShowDialog: canShowClockInDialog } = useDialogVisibility('clock_in_do_not_show');
  const location = useLocation();
  const navigate = useNavigate();
  const { patients, patientDetails, episodeOfCare, details, createDocument, editDocument } = paths;
  const anchorRef = useRef<any>(null);
  const episodeOfCareId = location?.state?.episodeOfCareId;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(1);
  const getAllTemplates = useSelector((state: any) => state.getAllTemplatesReducer);
  const [allTemplates, setAllTemplates] = useState<any>([]);
  const [draftDocuments, setDraftDocuments] = useState<string[]>([]);
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);
  const isPatientDataLoaded = useSelector((state: any) => state.getSinglePatientReducer.loading);
  const therapistDiscipline = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.discipline
  );

  const thePayComeDetailsReducer = useSelector(
    (state: any) => state.thePayComeDetailsReducer?.response?.data
  );

  const therapistId = useSelector(
    (state: any) => state.getTherapistProfileReducer?.response?.data?.providerId
  );
  const episodeOfCareRequiredDocumentData = useSelector(
    (state: any) => state.getEpisodeOfCareRequiredDocumentReducer
  );
  const requiredDocs = useSelector((state: any) => state.getEpisodeOfCareRequiredDocumentReducer?.response?.content)
  const docSettings = useSelector((state: any) => state.dueDocSettingsReducer?.response?.data)
  const episodeOfCareData = useSelector((state: any) => state?.getSingleEpisodeOfCare?.response);
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.currentPermissions
  );
  const getSignatureAccess = useSelector((state: any) => state.getSignatureAccessReducer);
  const { CREATE_RECERTIFICATION, CREATE_EVAL, UPDATE_RECERTIFICATION, UPDATE_EVAL } = permissions;
  const checkDeleteRequiredDocument = useSelector(
    (state: any) => state.deleteRequiredDocumentReducer
  );
  const checkPendingDocsAlert = useSelector((state: any) => state.checkPendingDocsAlert);
  const [isDeleteAlertOn] = useFeatureToggle(deleteDocumentAlertTreatment, 'FACILITY');
  const [reFormsPtEvalEnabled] = useFeatureToggle(reFormsPtEvalTreatment, 'FACILITY');
  const [reFormsOtEvalEnabled] = useFeatureToggle(reFormsOtEvalTreatment, 'FACILITY');
  const [reFormsSlpEvalEnabled] = useFeatureToggle(reFormsSlpEvalTreatment, 'FACILITY');
  const [reFormsPtProgressNoteEnabled] = useFeatureToggle(
    reFormsPtProgressNoteTreatment,
    'FACILITY'
  );
  const [reFormsOtProgressNoteEnabled] = useFeatureToggle(
    reFormsOtProgressNoteTreatment,
    'FACILITY'
  );
  const [reFormsSlpProgressNoteEnabled] = useFeatureToggle(
    reFormsSlpProgressNoteTreatment,
    'FACILITY'
  );
  const [reFormsOtRecertEnabled] = useFeatureToggle(reFormsOtRecertTreatment, 'FACILITY');
  const [reFormsPtRecertEnabled] = useFeatureToggle(reFormsPtRecertTreatment, 'FACILITY');
  const [reFormsSlpRecertEnabled] = useFeatureToggle(reFormsSlpRecertTreatment, 'FACILITY');
  const [reFormsOtDischargeEnabled] = useFeatureToggle(reFormsOtDischargeTreatment, 'FACILITY');
  const [reFormsPtDischargeEnabled] = useFeatureToggle(reFormsPtDischargeTreatment, 'FACILITY');
  const [reFormsSlpDischargeEnabled] = useFeatureToggle(reFormsSlpDischargeTreatment, 'FACILITY');
  const [reFormsDraftDocumentListEnabled] = useFeatureToggle(reFormsDraftDocumentList, 'FACILITY');

  const [isRecheckDischarge] = useFeatureToggleWhenReady(recheckDischarge, 'ENTERPRISE');
  const [isDocDuePNAlert] = useFeatureToggleWhenReady(DocDuePnAlert, 'FACILITY')

  useEffect(() => {
    if (!getAllTemplates.areGetTemplates && getAllTemplates.response !== null) return;

    const filteredTemplate = getAllTemplates.response?.filter((item: any) => {
      if (
        item.formType.includes('RECERTIFICATION') &&
        !permissionData?.includes(CREATE_RECERTIFICATION)
      ) {
        return;
      } else if (item.formType.includes('EVALUATION') && !permissionData?.includes(CREATE_EVAL)) {
        return;
      } else if (
        (!reFormsPtEvalEnabled && item.formType === 'EVALUATION_REFORM_PT') ||
        (!reFormsOtEvalEnabled && item.formType === 'EVALUATION_REFORM_OT') ||
        (!reFormsSlpEvalEnabled && item.formType === 'EVALUATION_REFORM_SLP') ||
        (!reFormsPtProgressNoteEnabled && item.formType === 'WEEKLY_PROGRESS_NOTE_REFORM_PT') ||
        (!reFormsOtProgressNoteEnabled && item.formType === 'WEEKLY_PROGRESS_NOTE_REFORM_OT') ||
        (!reFormsSlpProgressNoteEnabled && item.formType === 'WEEKLY_PROGRESS_NOTE_REFORM_SLP') ||
        (!reFormsOtRecertEnabled && item.formType === 'RECERTIFICATION_REFORM_OT') ||
        (!reFormsPtRecertEnabled && item.formType === 'RECERTIFICATION_REFORM_PT') ||
        (!reFormsSlpRecertEnabled && item.formType === 'RECERTIFICATION_REFORM_SLP') ||
        (!reFormsOtDischargeEnabled && item.formType === 'DISCHARGE_REFORM_OT') ||
        (!reFormsPtDischargeEnabled && item.formType === 'DISCHARGE_REFORM_PT') ||
        (!reFormsSlpDischargeEnabled && item.formType === 'DISCHARGE_REFORM_SLP')
      ) {
        return;
      } else {
        return item;
      }
    });

    if (
      reFormsPtEvalEnabled ||
      reFormsOtEvalEnabled ||
      reFormsSlpEvalEnabled ||
      reFormsPtProgressNoteEnabled ||
      reFormsOtProgressNoteEnabled ||
      reFormsSlpProgressNoteEnabled ||
      reFormsOtRecertEnabled ||
      reFormsPtRecertEnabled ||
      reFormsSlpRecertEnabled ||
      reFormsOtDischargeEnabled ||
      reFormsPtDischargeEnabled ||
      reFormsSlpDischargeEnabled
    ) {
      const reformTemplates: typeof filteredTemplate = [];

      filteredTemplate.forEach((template: any) => {
        if (
          (reFormsPtEvalEnabled && template.formType === 'EVALUATION_REFORM_PT') ||
          (reFormsOtEvalEnabled && template.formType === 'EVALUATION_REFORM_OT') ||
          (reFormsSlpEvalEnabled && template.formType === 'EVALUATION_REFORM_SLP') ||
          (reFormsPtProgressNoteEnabled &&
            template.formType === 'WEEKLY_PROGRESS_NOTE_REFORM_PT') ||
          (reFormsOtProgressNoteEnabled &&
            template.formType === 'WEEKLY_PROGRESS_NOTE_REFORM_OT') ||
          (reFormsSlpProgressNoteEnabled &&
            template.formType === 'WEEKLY_PROGRESS_NOTE_REFORM_SLP') ||
          (reFormsOtRecertEnabled && template.formType === 'RECERTIFICATION_REFORM_OT') ||
          (reFormsPtRecertEnabled && template.formType === 'RECERTIFICATION_REFORM_PT') ||
          (reFormsSlpRecertEnabled && template.formType === 'RECERTIFICATION_REFORM_SLP') ||
          (reFormsOtDischargeEnabled && template.formType === 'DISCHARGE_REFORM_OT') ||
          (reFormsPtDischargeEnabled && template.formType === 'DISCHARGE_REFORM_PT') ||
          (reFormsSlpDischargeEnabled && template.formType === 'DISCHARGE_REFORM_SLP')
        ) {
          reformTemplates.push(template.formType.replace('_REFORM_', '_'));
        }
      });

      setAllTemplates(
        filteredTemplate.filter((template: any) => {
          return !reformTemplates.includes(template.formType);
        })
      );
    } else {
      if (filteredTemplate) {
        setAllTemplates(
          filteredTemplate.filter((template: any) => {
            return !template.formType.includes('_REFORM_');
          })
        );
      }
    }
  }, [getAllTemplates]);

  useEffect(() => {
    const discipline = activeTab === 'PT' ? 'PT' : activeTab === 'OT' ? 'OT' : 'SLP';
    const realm = getRealmName();

    if (!realm) {
      return;
    }

    getDraftDocuments(episodeOfCareId, discipline, getRealmName() || '').then(
      (response: DraftDocument[]) => {
        const draftDocuments = response.map((draftDocument) => draftDocument.documentType);
        setDraftDocuments(draftDocuments);
      }
    );
  }, [activeTab, episodeOfCareId]);

  const callRequiredDocuments = () => {
    dispatch(
      getEpisodeOfCareRequiredDocument({
        therapistId: therapistId,
        signal: abortControllerScheduledDocumentRef.current.signal,
        params: {
          episodeOfCareId: episodeOfCareId,
          type: activeTab,
          page,
          pageSize: 10,
          sortBy: 'dueDate',
          sortDirection: 'desc',
        },
      })
    );
    dispatch(requestDocDueSettings({
      params: {
        payerType: episodeOfCareData?.payerPlanEntity?.payerPlanType,
        discipline: activeTab
      }
    }))
  };

  const [successModal, setSuccessModal] = useState({
    success: false,
    warning: false,
  });

  const handleCloseSuccess = () => {
    setSuccessModal({
      success: false,
      warning: false,
    });
  };

  const checkoutResponse = useSelector((state: any) => state.checkoutReducer);

  //clock in modal

  const [isClockIn, setIsClockIn] = useState(false);
  const [notToShowAgain, setNotToShowAgain] = useState(false);
  const [actionToBeContinue, setActionToBeContinue] = useState('');
  const [navigateDoc, setNavigateDoc] = useState<NavigateDoc | null>(null);
  const [editDocumentAction, setEditDocumentAction] = useState<any>('');

  //pagination logic

  const [rowPerPage, setRowPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [sortBy, setSortBy] = useState('dueDate');
  const [sortOrderArray, setSortArray] = useState<any>(['desc', 'desc', 'desc', 'desc', 'desc']);

  const onPageChange = (event: any, newPage: number) => {
    dispatch(
      getEpisodeOfCareRequiredDocument({
        therapistId: therapistId,
        signal: abortControllerScheduledDocumentRef.current.signal,
        params: {
          episodeOfCareId: episodeOfCareId,
          type: activeTab,
          page: newPage,
          pageSize: rowPerPage,
          sortBy: sortBy,
          sortDirection: getSortOrder(sortBy),
        },
      })
    );
    setPage(newPage);
  };
  const onRowsPerPageChange = (event: any) => {
    const newRowsPerPage = event.target.value;
    setRowPerPage(newRowsPerPage);
    dispatch(
      getEpisodeOfCareRequiredDocument({
        therapistId: therapistId,
        signal: abortControllerScheduledDocumentRef.current.signal,
        params: {
          episodeOfCareId: episodeOfCareId,
          type: activeTab,
          page: 0,
          pageSize: newRowsPerPage,
          sortBy: sortBy,
          sortDirection: getSortOrder(sortBy),
        },
      })
    );
    setPage(0);
  };

  const resetPagination = () => {
    setPage(0);
    setRowPerPage(10);
    setSortBy('dueDate');
    setSortArray(['desc', 'desc', 'desc', 'desc', 'desc']);
  };

  useEffect(() => {
    if (!activeTab || !episodeOfCareData) return;
    abortControllerScheduledDocumentRef.current = new AbortController();
    callRequiredDocuments();
    resetPagination();
  }, [activeTab, episodeOfCareData]);

  useEffect(() => {
    if (!checkoutResponse?.isGetCheckIn && checkoutResponse?.response === null) return;
    if (!checkoutResponse.isGetCheckIn && checkoutResponse?.response !== null) {
      setSuccessModal({
        success: false,
        warning: true,
      });
      return;
    }
    if (checkoutResponse.isGetCheckIn && checkoutResponse?.response !== null) {
      if (checkoutResponse?.clockAction === 'CLOCK_IN_SUCCESS') {
        setSuccessModal({
          success: true,
          warning: false,
        });
        if (actionToBeContinue === 'CREATE_NEW_DOCUMENT') {
          dispatch(resetEocDocumentCreateDataAction());
          dispatch(
            getEocDocumentCreateDataAction({
              document: navigateDoc,
              activeTab,
              patientData,
              episodeOfCareId,
            })
          );

          // discharge doc prevent
          if (isRecheckDischarge && navigateDoc?.formType?.includes('DISCHARGE')) {
            dispatch(
              checkPendingDocsAlertAction({
                eocId: episodeOfCareId,
                params: {
                  discipline: activeTab,
                  localDate: moment(new Date()).format('YYYY-MM-DD'),
                },
              })
            );
            return;
          }

          navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${createDocument}`, {
            state: {
              document: navigateDoc,
              activeTab,
              patientData,
              episodeOfCareId,
            },
          });
          return;
        }
        if (actionToBeContinue === 'EDIT_DOCUMENT') {
          dispatch(resetEocDocumentCreateDataAction());
          dispatch(
            getEocDocumentCreateDataAction({
              document: editDocumentAction,
              activeTab,
              patientData,
              episodeOfCareId,
              requiredDocument: true,
            })
          );
          // discharge doc prevent
          if (isRecheckDischarge && editDocumentAction?.formType?.includes('DISCHARGE')) {
            dispatch(
              checkPendingDocsAlertAction({
                eocId: episodeOfCareId,
                params: {
                  discipline: activeTab,
                  localDate: moment(new Date()).format('YYYY-MM-DD'),
                },
              })
            );
            return;
          }
          navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${createDocument}`, {
            state: {
              document: editDocumentAction,
              activeTab,
              patientData,
              episodeOfCareId,
              requiredDocument: true,
            },
          });
        }
      }
    }
  }, [checkoutResponse]);

  const handleIsClock = () => {
    if (actionToBeContinue === 'CREATE_NEW_DOCUMENT') {
      dispatch(resetEocDocumentCreateDataAction());
      dispatch(
        getEocDocumentCreateDataAction({
          document: navigateDoc,
          activeTab,
          patientData,
          episodeOfCareId,
        })
      );

      // discharge doc prevent
      if (isRecheckDischarge && navigateDoc?.formType?.includes('DISCHARGE')) {
        dispatch(
          checkPendingDocsAlertAction({
            eocId: episodeOfCareId,
            params: {
              discipline: activeTab,
              localDate: moment(new Date()).format('YYYY-MM-DD'),
            },
          })
        );
        // setNotToShowAgain(true);
        setIsClockIn(false);
        return;
      }
      navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${createDocument}`, {
        state: {
          document: navigateDoc,
          activeTab,
          patientData,
          episodeOfCareId,
        },
      });
      return;
    }
    if (actionToBeContinue === 'EDIT_DOCUMENT') {
      dispatch(resetEocDocumentCreateDataAction());
      dispatch(
        getEocDocumentCreateDataAction({
          document: editDocumentAction,
          activeTab,
          patientData,
          episodeOfCareId,
          requiredDocument: true,
        })
      );
      // discharge doc prevent
      if (isRecheckDischarge && editDocumentAction?.formType?.includes('DISCHARGE')) {
        dispatch(
          checkPendingDocsAlertAction({
            eocId: episodeOfCareId,
            params: {
              discipline: activeTab,
              localDate: moment(new Date()).format('YYYY-MM-DD'),
            },
          })
        );
        // setNotToShowAgain(true);
        setIsClockIn(false);
        return;
      }
      navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${createDocument}`, {
        state: {
          document: editDocumentAction,
          activeTab,
          patientData,
          episodeOfCareId,
          requiredDocument: true,
        },
      });
    }
    setNotToShowAgain(true);
    setIsClockIn(false);
  };

  const [showDischargeModal, setShowDischargeModal] = useState<boolean>(false);

  useEffect(() => {
    if (!checkPendingDocsAlert?.isSuccess && checkPendingDocsAlert?.response === null) return;
    if (!checkPendingDocsAlert?.isSuccess && checkPendingDocsAlert?.response !== null) return;

    if (checkPendingDocsAlert?.response?.length) {
      setShowDischargeModal(true);
      return;
    }
    // navigate to discharge
    dispatch(resetPendingDocsAlertAction())
    navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${createDocument}`, {
      state: {
        document: navigateDoc,
        activeTab,
        patientData,
        episodeOfCareId,
      },
    });
  }, [checkPendingDocsAlert]);

  const handleMenuItemClick = useCallback(
    (index: number, document: NavigateDoc): void => {
      setNavigateDoc(document);
      setSelectedIndex(index);

      if (
        canShowClockInDialog() &&
        !isRunning &&
        !notToShowAgain &&
        !thePayComeDetailsReducer?.enablePaycom &&
        !thePayComeDetailsReducer?.enableHostedTime &&
        !thePayComeDetailsReducer?.enablePaylocity
      ) {
        setActionToBeContinue('CREATE_NEW_DOCUMENT');
        setIsClockIn(true);
        return;
      }

      setOpen(false);
      dispatch(resetEocDocumentCreateDataAction());
      dispatch(
        getEocDocumentCreateDataAction({
          document,
          activeTab,
          patientData,
          episodeOfCareId,
        })
      );
      //add discharge prevent
      if (isRecheckDischarge && document.formType?.includes('DISCHARGE')) {
        dispatch(
          checkPendingDocsAlertAction({
            eocId: episodeOfCareId,
            params: {
              discipline: activeTab,
              localDate: moment(new Date()).format('YYYY-MM-DD'),
            },
          })
        );
        return;
      }
      navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${createDocument}`, {
        state: {
          document,
          activeTab,
          patientData,
          episodeOfCareId,
        },
      });
    },
    [activeTab, patientData, notToShowAgain, isRunning, thePayComeDetailsReducer]
  );

  const handleToggle = useCallback((): void => {
    setOpen((prevOpen) => !prevOpen);
  }, []);

  useEffect(() => {
    dispatch(resetUuidAction());
  }, []);

  const handleClose = useCallback((event: Event): void => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setOpen(false);
  }, []);

  const showDocumentForEdit = useCallback(
    (event: any, document: any) => {
      setEditDocumentAction(document);
      //display clock in modal
      if (
        canShowClockInDialog() &&
        !isRunning &&
        !notToShowAgain &&
        !thePayComeDetailsReducer?.enablePaycom &&
        !thePayComeDetailsReducer?.enableHostedTime &&
        !thePayComeDetailsReducer?.enablePaylocity
      ) {
        setActionToBeContinue('EDIT_DOCUMENT');
        setIsClockIn(true);
        return;
      }
      dispatch(resetEocDocumentCreateDataAction());
      dispatch(
        getEocDocumentCreateDataAction({
          document,
          activeTab,
          patientData,
          episodeOfCareId,
          requiredDocument: true,
        })
      );

      //add discharge prevent
      if (isRecheckDischarge && document.formType?.includes('DISCHARGE')) {
        dispatch(
          checkPendingDocsAlertAction({
            eocId: episodeOfCareId,
            params: {
              discipline: activeTab,
              localDate: moment(new Date()).format('YYYY-MM-DD'),
            },
          })
        );
        return;
      }
      navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${createDocument}`, {
        state: {
          document,
          activeTab,
          patientData,
          episodeOfCareId,
          requiredDocument: true,
        },
      });
    },
    [
      document,
      activeTab,
      patientData,
      episodeOfCareId,
      notToShowAgain,
      isRunning,
      thePayComeDetailsReducer,
    ]
  );

  const checkEditPermission = (document: any) => {
    if (document.formType?.includes('DAILY_SOAP_NOTE')) {
      return false;
    }

    if (
      document.formType?.includes('RECERTIFICATION') &&
      !permissionData.includes(UPDATE_RECERTIFICATION)
    ) {
      return false;
    }
    if (document.formType?.includes('EVALUATION') && !permissionData.includes(UPDATE_EVAL)) {
      return false;
    }
    return true;
  };

  const HandleStartClock = () => {
    const millageInfo = {
      locationType: 'BUILDING',
      payByMilage: null,
    };
    startStopwatch('MILLAGE', millageInfo);
  };

  const [openDeleteAlertModal, setOpenDeleteModal] = useState<boolean>(false);
  const [forDeleteDocument, setForDeletedocument] = useState<DocumentData | null>(null);

  const handleDeleteRequiredDocument = () => {
    dispatch(deleteRequiredDocumentAction(forDeleteDocument?.uuid || ''));
  };

  const openDeleteConfirmModal = (document: DocumentData) => {
    setForDeletedocument(document);
    setOpenDeleteModal(true);
  };

  const closeDeleteConfirmModal = () => {
    setForDeletedocument(null);
    dispatch(resetDeleteRequiredDocumentAction());
    setOpenDeleteModal(false);
  };

  useEffect(() => {
    if (checkDeleteRequiredDocument.response === null && !checkDeleteRequiredDocument.isDocDeleted)
      return;
    if (checkDeleteRequiredDocument.isDocDeleted) {
      callRequiredDocuments();
      closeDeleteConfirmModal();
    }
  }, [checkDeleteRequiredDocument]);
  const theme = useTheme();

  const createSortHandler = (columnId: string, index: number) => {
    const isAsc = sortOrderArray[index] === 'asc';
    const newSortOrderArray = ['desc', 'desc', 'desc', 'desc', 'desc'];
    newSortOrderArray[index] = isAsc ? 'desc' : 'asc';

    dispatch(
      getEpisodeOfCareRequiredDocument({
        therapistId: therapistId,
        signal: abortControllerScheduledDocumentRef.current.signal,
        params: {
          episodeOfCareId: episodeOfCareId,
          type: activeTab,
          page,
          pageSize: rowPerPage,
          sortBy: columnId,
          sortDirection: getSortOrder1(columnId, newSortOrderArray),
        },
      })
    );
    setSortArray(newSortOrderArray);
    setSortBy(columnId);
  };

  const getSortOrder1 = (sortColumn: string, newSortOrderArray: any) => {
    switch (sortColumn) {
      case 'documentType':
        return newSortOrderArray[0];
      case 'dueDate':
        return newSortOrderArray[1];
      case 'dueStatus':
        return newSortOrderArray[2];
      default:
        return '';
    }
  };

  const getSortOrder = (sortColumn: string) => {
    switch (sortColumn) {
      case 'documentType':
        return sortOrderArray[0];
      case 'dueDate':
        return sortOrderArray[1];
      case 'dueStatus':
        return sortOrderArray[2];
      default:
        return '';
    }
  };

  const oldestUuid = useMemo(() => {
    return episodeOfCareRequiredDocumentData.response?.content ? getOldestRequiredDocumentUuid([...episodeOfCareRequiredDocumentData.response.content]) : undefined;
  }, [episodeOfCareRequiredDocumentData.response?.content]); 
  
  return (
    <Box
      // sx={{ border: '1px solid #F2F4F7', borderRadius: '20px' }}
      p={3}
    >
      <Card>
        <Grid
          container
          sx={{ padding: '18px 24px 18px 24px', position: 'relative' }}
        >
          <Typography variant="h6">Required Documents</Typography>
          <Box
            sx={{
              border: '1px solid rgba(0, 0, 0, 0.26)',
              borderRadius: '12px',
              padding: '3px',
              display: 'flex',
              alignItems: 'center',
              marginLeft: '12px',
            }}
          >
            <Typography sx={{ color: '#111927', fontSize: '13px', letterSpacing: '0.16px' }}>
              {episodeOfCareRequiredDocumentData?.response?.totalElements
                ? `${episodeOfCareRequiredDocumentData?.response?.totalElements} Documents`
                : `0 Document`}
            </Typography>
          </Box>
          {therapistDiscipline === activeTab && (
            <Button
              onClick={handleToggle}
              startIcon={
                getAllTemplates.loading || isPatientDataLoaded ? (
                  <img
                    src={loader}
                    style={{ height: 30 }}
                    alt=""
                  />
                ) : (
                  <Add />
                )
              }
              sx={{ position: 'absolute', right: 0 }}
              ref={anchorRef}
              disabled={
                getAllTemplates.loading ||
                isPatientDataLoaded ||
                episodeOfCareData?.status !== 'OPENED'
              }
            >
              Create Document
            </Button>
          )}

          <Popper
            anchorEl={anchorRef.current}
            open={open}
            transition
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                  boxShadow: '0px 3px 14px 0px rgba(0, 0, 0, 0.08)',
                  borderRadius: '12px',
                  background: '#fff',
                  width: 'auto',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList>
                      {allTemplates?.map((template: any, index: number) => {
                        return (
                          checkSupervisorPermission(
                            getSignatureAccess.response?.data?.t2,
                            template.formType
                          ) && (
                            <MenuItem
                              key={template.uuid}
                              onClick={() => handleMenuItemClick(index, template)}
                              selected={index === selectedIndex}
                              sx={{ background: 'yello' }}
                            >
                              <Grid
                                container
                                sx={{ padding: '4px 8px 4px 8px' }}
                              >
                                <SvgIcon>{<GetDocumentIcon docType={template.formType} />}</SvgIcon>
                                <Typography sx={{ fontSize: '12px', marginLeft: '6px' }}>
                                  {template.formType
                                    ?.split('_')
                                    .map((item: string) =>
                                      ['PT', 'OT', 'SLP'].includes(item)
                                        ? item
                                        : item.slice(0, 1) +
                                          item.slice(1, item.length).toLowerCase()
                                    )
                                    .join(' ')
                                    .replace('Reform ', ' ')}
                                  {reFormsDraftDocumentListEnabled &&
                                    draftDocuments.includes(template.formType) && (
                                      <Chip
                                        variant="outlined"
                                        color="warning"
                                        size="small"
                                        label="DRAFT"
                                        sx={{
                                          marginLeft: '0.5rem',
                                          borderColor: theme.palette.warning.main,
                                          fontSize: '0.625rem',
                                        }}
                                      />
                                    )}
                                </Typography>
                              </Grid>
                            </MenuItem>
                          )
                        );
                      })}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Grid>
        <Divider />
        <Scrollbar>
          <Table sx={{ minWidth: 700 }}>
            <TableHead>
              <TableRow>
                {columns?.map((column: any, index: any) => (
                  <TableCell
                    key={column.id}
                    align={column?.align}
                  >
                    {column.id !== 'action' && column.id !== 'visit' ? (
                      <TableSortLabel
                        active={true}
                        direction={sortOrderArray[index]}
                        onClick={() => createSortHandler(column.id, index)}
                      >
                        {column.label}
                      </TableSortLabel>
                    ) : (
                      column.label
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {episodeOfCareRequiredDocumentData?.loading ? (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Box
                      textAlign="center"
                      p={3}
                    >
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : episodeOfCareRequiredDocumentData?.response?.totalElements ? (
                episodeOfCareRequiredDocumentData.response?.content.map(
                  (e: DocumentData, index: number) => {
                    return (
                      <TableRow key={index}>
                        <TableCell>{e.documentType}</TableCell>
                        <TableCell>
                          {Number(e?.visits?.split('/')[0]) === 0 && e.dueDate === null ? (
                            'Supervisory visit has not been scheduled'
                          ) : (
                            <Box>
                              {e.dueDate
                                ? format(
                                    new Date(
                                      new Date(e.dueDate).valueOf() +
                                        new Date(e.dueDate).getTimezoneOffset() * 60 * 1000
                                    ),
                                    'dd MMM, yyyy'
                                  )
                                : '-'}
                            </Box>
                          )}
                          {e.dueDate !== null && (
                            <Typography
                              sx={{ color: '#6C737F' }}
                              variant="caption"
                            >
                              {getDisplayString(e.dueDate, true, e, docSettings?.progressNoteDays, '', isDocDuePNAlert)}
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell>
                          <Status label={e?.visits || '-'} />
                        </TableCell>
                        <TableCell>

                          <Status label={e?.status || '-'} />
                        </TableCell>
                        <TableCell align="right">
                          {therapistDiscipline === e.type &&
                            checkEditPermission(document) &&
                            checkSupervisorPermission(
                              getSignatureAccess.response?.data?.t2,
                              e?.formType
                            ) && oldestUuid === e?.uuid && (
                              <IconButton
                                title="Create Document"
                                onClick={(event) => showDocumentForEdit(event, e)}
                              >
                                <PlusIcon />
                              </IconButton>
                            )}
                          {isDeleteAlertOn && (
                            <IconButton
                              title="Delete Alert"
                              onClick={() => openDeleteConfirmModal(e)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  }
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={7}>
                    <Box
                      textAlign="center"
                      p={3}
                    >
                      <Typography
                        color={'text.secondary'}
                        variant="subtitle2"
                      >
                        No Records Found
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Scrollbar>
        <TablePagination
          component="div"
          count={episodeOfCareRequiredDocumentData?.response?.totalElements || 0}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          page={page}
          rowsPerPage={rowPerPage}
          rowsPerPageOptions={[10, 15, 30]}
        />
      </Card>

      {/* clock in modal */}
      {canShowClockInDialog() && (
        <BootstrapDialog
          PaperProps={{ style: { maxWidth: '750px' } }}
          onClose={() => setIsClockIn(false)}
          aria-labelledby="customized-dialog-title"
          open={isClockIn && !notToShowAgain}
        >
          <ClockInOutModal
            close={handleIsClock}
            handleClockIn={HandleStartClock}
          />
        </BootstrapDialog>
      )}

      {/* success modal */}

      <Modal open={successModal?.success || successModal?.warning}>
        <SucessModal
          close={handleCloseSuccess}
          isSucess={successModal.success}
          title={successModal?.success ? 'Clock In successfully' : 'Clock in Failed'}
          message=""
        />
      </Modal>

      {/* Delete Alert Modal */}
      <BootstrapDialog
        PaperProps={{ style: { maxWidth: '750px' } }}
        onClose={closeDeleteConfirmModal}
        aria-labelledby="customized-dialog-title"
        open={openDeleteAlertModal}
      >
        <CommonConfirmDeleteModal
          close={closeDeleteConfirmModal}
          handleDelete={handleDeleteRequiredDocument}
          title="Delete Document Alert"
          message={`Are you sure you want to delete this request? - ${forDeleteDocument?.documentType}`}
          isDisabled={checkDeleteRequiredDocument?.loading}
        />
      </BootstrapDialog>

      {/* Discharge Alert */}
      <BootstrapDialog
        PaperProps={{ style: { maxWidth: '100%' } }}
        onClose={() => setShowDischargeModal(false)}
        aria-labelledby="customized-dialog-title"
        open={showDischargeModal}
      >
        <DischargeRecheckModal
          handleDelete={() => setShowDischargeModal(false)}
          title="and Discharge"
          message={`The following items have not been completed.`}
          buttontext="Got it"
          requiredDocument = {actionToBeContinue === 'EDIT_DOCUMENT' ? true : false}
          document={actionToBeContinue === 'CREATE_NEW_DOCUMENT' ? navigateDoc : editDocumentAction}
          source='EOC'
        />
      </BootstrapDialog>
    </Box>
  );
};

export default ViewDocumentList;
